import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import InputAdornment from '@mui/material/InputAdornment';

const PAYMENT_METHODS = [
  { label: 'Nakit', value: 'CASH' },
  { label: 'Kart', value: 'CARD' },
  { label: 'Havale', value: 'BANK_TRANSFER' },
];

function getTodayISO() {
  return new Date().toISOString().slice(0, 10);
}

export default function MarkExpensePaidModal({ open, expense, onClose, onSubmit }) {
  const [form, setForm] = React.useState({
    paidDate: getTodayISO(),
    paymentMethod: 'CASH',
    amountTry: '',
    note: '',
  });

  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setForm({
        paidDate: getTodayISO(),
        paymentMethod: 'CASH',
        amountTry: expense?.amountTry ?? '',
        note: expense?.note ?? '',
      });
      setErrors({});
      setSubmitting(false);
    }
  }, [open, expense]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const next = {};

    if (!form.paidDate) next.paidDate = 'Ödeme tarihi gerekli.';
    if (!form.paymentMethod) next.paymentMethod = 'Ödeme yöntemi gerekli.';
    if (!form.amountTry || Number(form.amountTry) <= 0) next.amountTry = 'Geçerli bir tutar gir.';

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setSubmitting(true);
      await onSubmit?.({
        paidDate: form.paidDate,
        paymentMethod: form.paymentMethod,
        amountTry: Number(form.amountTry),
        note: form.note?.trim() || null,
      });
      onClose?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Gideri ödendi yap</DialogTitle>

      <DialogContent>
        <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Gider"
              value={expense?.title || 'Gider'}
              size="small"
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Ödeme tarihi"
              value={form.paidDate}
              onChange={handleChange('paidDate')}
              size="small"
              error={!!errors.paidDate}
              helperText={errors.paidDate}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              select
              label="Ödeme yöntemi"
              value={form.paymentMethod}
              onChange={handleChange('paymentMethod')}
              size="small"
              error={!!errors.paymentMethod}
              helperText={errors.paymentMethod}
            >
              {PAYMENT_METHODS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="Tutar"
              value={form.amountTry}
              onChange={handleChange('amountTry')}
              size="small"
              error={!!errors.amountTry}
              helperText={errors.amountTry}
              InputProps={{
                startAdornment: <InputAdornment position="start">₺</InputAdornment>,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Not"
              value={form.note}
              onChange={handleChange('note')}
              size="small"
              multiline
              minRows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Vazgeç
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          startIcon={<Icon>check</Icon>}
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
